import { createContext } from 'react';

import { ConvertInvoiceToRaContextValue } from '../types';

export const ConvertInvoiceToRaContext =
  createContext<ConvertInvoiceToRaContextValue>(null);
